module.exports = __webpack_public_path__ + "static/notification_image_2-66e723182624ea193ad4a32d2d121917.jpg";